module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "job-overview m-t-lg m-b-lg"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-load-breakdown list-detail-load-breakdown-carrier"
  }, [_vm._l((_vm.loads), function(load) {
    return _c('load-item', {
      key: load.id,
      attrs: {
        "load": load
      }
    })
  }), _vm._v(" "), (_vm.haveNoLoads) ? _c('li', {
    staticClass: "text-center text-muted"
  }, [_c('strong', [_vm._v("No loads found.")])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'loads.index'
      }
    }
  }, [_vm._v("View All Scheduled Loads")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('i', {
    staticClass: "far fa-clipboard-list"
  }), _vm._v(" Loads")])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-a1f107fe"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/LoadList.vue
// module id = 1067
// module chunks = 0